export const PROHIBITED_BUSINESS_INDUSTRIES = [
  'DatingOrAdultEntertainment',
  'EscortServices',
  'Cannabis',
  'DirectMarketingOrTelemarketing',
  'Cryptocurrency',
  'DebtCollection',
  'MoneyServiceBusinesses',
  'PaydayLending',
  'Gambling'
];
